var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.$t.__(
              "listing.settings.ListingSettingsColumn.tooltip.can_not_hide"
            ),
            disabled: !_vm.column.isDefault,
            placement: "top-start",
            arrow: false
          }
        },
        [
          _c("CompassCheckbox", {
            attrs: {
              modelValue: _vm.column.label,
              label: _vm.column.label,
              disabled: _vm.column.isDefault,
              checked: _vm.column.isVisible
            },
            on: {
              change: function($event) {
                return _vm.$emit("checkboxChange")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.hasSearchQuery
        ? _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.$t.__(
                  "listing.settings.ListingSettingsColumn.tooltip.can_not_move"
                ),
                disabled: _vm.column.isMovable,
                placement: "top-start",
                arrow: false
              }
            },
            [
              _c(
                "div",
                { staticClass: "listing-settings-column-item__actions" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "listing-settings-column-item__actions-order"
                    },
                    [
                      _c("CompassIconButton", {
                        staticClass:
                          "listing-settings-column-item__actions-order--up",
                        attrs: {
                          disabled: !_vm.canBeMovedUp,
                          icon: "caret-up",
                          size: "extra-small"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("mooveUp")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassIconButton", {
                        staticClass:
                          "listing-settings-column-item__actions-order--down",
                        attrs: {
                          disabled: !_vm.canBeMovedDown,
                          icon: "caret-down",
                          size: "extra-small"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("mooveDown")
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("CompassIcon", {
                    attrs: {
                      icon: "drag-and-drop",
                      type: _vm.column.isMovable ? "primary" : "disabled"
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }